import React, { PureComponent } from "react";

import TTNavComponent from "./TTNavComponent";
import styles from "./SubMenu.local.scss";
import classnames from "classnames";
import _ from "i18n";
import { getCommunityRoute } from "Utils";

export default class SubMenuComponent extends PureComponent {
  getRoute = type => {
    const { navCommunity } = this.props;
    const helpUrl = !navCommunity ? "/" : getCommunityRoute(navCommunity);

    if (type === "ALBUM") {
      return `${helpUrl}/albums`;
    }

    return `${helpUrl}/${type.toLowerCase()}`;
  };

  render() {
    const { navCommunity, direction, changeMenuDirection } = this.props;

    return (
      <div
        className={classnames(
          styles.submenu,
          direction === "VERTICAL" ? styles.vertical : ""
        )}
      >
        <span className={styles.flip} onClick={changeMenuDirection}>
          <i className="icon icon-menu" />
        </span>
        <ul>
          <li className={styles.nav}>
            <TTNavComponent
              label={_("WELCOME")}
              url={`${getCommunityRoute(navCommunity)}`}
              icon="home"
            />
          </li>
          <li className={styles.nav}>
            <TTNavComponent
              label={_("MY MEDIAS")}
              url={`${getCommunityRoute(navCommunity)}/my-medias`}
              icon="picture"
            />
          </li>
          <li className={styles.nav}>
            <TTNavComponent
              label={_("LIBRARY")}
              url={`${getCommunityRoute(navCommunity)}/library`}
              icon="layers"
            />
          </li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/SubMenu/SubMenuComponent.js